// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import queryString from 'query-string';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getScreenCapture = createAsyncThunk('getAllScreenCaptureSlice/getScreenCapture', async (data) => {
    const query = queryString.stringify(data);
    try {
        let response = await axios.get('/ScreenTracker/screen-capture?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getUserOption = createAsyncThunk('getAllScreenCaptureSlice/getUserOption', async () => {
    try {
        let response = await axios.get('/User?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const screenCaptureSlice = createSlice({
    name: 'getAllScreenCaptureSlice',

    initialState: {
        screenCapture: [],
        userOption: []
    },
    reducers: {
        removeScreenCapture: (state) => {
            state.screenCapture = [];
        },
        removeUserOption: (state) => {
            state.userOption = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getScreenCapture.fulfilled, (state, action) => {
            state.screenCapture = action?.payload;
            return;
        });
        builder.addCase(getUserOption.fulfilled, (state, action) => {
            state.userOption = action?.payload;
            return;
        });
    }
});

export const { removeScreenCapture, removeUserOption } = screenCaptureSlice.actions;
export default screenCaptureSlice.reducer;
